// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpotsPage_pageHeader__sKx7V {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px;
}

.SpotsPage_pageTitle__8kOfI {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #0f172a;
}

.SpotsPage_pageSubtitle__Lx8B0 {
  margin: 6px 0 0;
  font-size: 0.95rem;
  color: #64748b;
  max-width: 480px;
  line-height: 1.45;
}

.SpotsPage_metrics__kq0V7 {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.SpotsPage_metric__hv5uu {
  min-width: 120px;
  padding: 12px 16px;
  border-radius: 14px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background: linear-gradient(135deg, rgba(248, 250, 252, 0.95), rgba(226, 232, 240, 0.65));
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.SpotsPage_metricValue__wqsKy {
  font-size: 1.45rem;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
}

.SpotsPage_metricLabel__Ncmxi {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.SpotsPage_actionsBar__EkLkn {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.SpotsPage_searchWrapper__41iWZ {
  flex: 1 1 280px;
  min-width: 220px;
}

.SpotsPage_createWrapper__gI54e {
  display: flex;
  align-items: center;
}

.SpotsPage_infoBanner__\\+GZa\\+ {
  width: 100%;
  margin-bottom: 20px;
}

.SpotsPage_spotsGrid__oSsR4 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
  width: 100%;
}

.SpotsPage_spotCard__-uj\\+6 {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.97), rgba(248, 250, 252, 0.96));
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 24px;
  box-shadow: 0 24px 45px -30px rgba(15, 23, 42, 0.4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.SpotsPage_cardMedia__A5bQD {
  position: relative;
  width: 100%;
  padding-top: 58%;
  background: rgba(15, 23, 42, 0.03);
}

.SpotsPage_spotImage__bPULC {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.SpotsPage_spotBadge__yz6Mm {
  position: absolute;
  top: 14px;
  left: 14px;
  background: rgba(15, 23, 42, 0.72);
  color: #f8fafc;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 999px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.35);
}

.SpotsPage_cardBody__zqrY6 {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.SpotsPage_cardHeader__2Ymym {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.SpotsPage_cardTitle__9ZgFn {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
}

.SpotsPage_cardSubtitle__WPpit {
  margin: 0;
  font-size: 0.95rem;
  color: #64748b;
  line-height: 1.4;
}

.SpotsPage_metaList__YjMC6 {
  display: grid;
  gap: 10px;
}

.SpotsPage_metaItem__58--- {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.SpotsPage_metaLabel__6tONP {
  font-size: 0.82rem;
  font-weight: 600;
  color: #475569;
  letter-spacing: 0.02em;
}

.SpotsPage_metaValue__bb74M {
  font-size: 0.9rem;
  font-weight: 500;
  color: #0f172a;
  text-align: right;
}

.SpotsPage_surveySection__jPt0P {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 14px;
  border: 1px solid rgba(37, 99, 235, 0.18);
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08), rgba(96, 165, 250, 0.05));
}

.SpotsPage_surveySectionEmpty__GL-Pt {
  border: 1px dashed rgba(148, 163, 184, 0.6);
  background: rgba(248, 250, 252, 0.55);
}

.SpotsPage_surveyTitle__I6\\+Cm {
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #2563eb;
}

.SpotsPage_surveyTitleEmpty__\\+5RV6 {
  color: #64748b;
}

.SpotsPage_surveyValue__ZJboI {
  font-size: 0.95rem;
  color: #0f172a;
  font-weight: 600;
}

.SpotsPage_surveyMeta__n8f2Q {
  font-size: 0.82rem;
  color: #475569;
}

.SpotsPage_progressSection__Ak\\+z\\+ {
  display: grid;
  gap: 10px;
}

.SpotsPage_progressLabel__icm1s {
  font-size: 0.82rem;
  color: #475569;
  font-weight: 600;
}

.SpotsPage_ctaGroup__1vEuS {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
}

.SpotsPage_divider__i9hdc {
  height: 1px;
  background: rgba(226, 232, 240, 0.7);
  margin: 0 -24px;
}

.SpotsPage_emptyState__sqYx8 {
  padding: 96px 24px;
  text-align: center;
  color: #94a3b8;
  font-size: 1.05rem;
  font-weight: 600;
}

@media (max-width: 600px) {
  .SpotsPage_cardBody__zqrY6 {
    padding: 20px;
  }

  .SpotsPage_metaItem__58--- {
    flex-direction: column;
    align-items: flex-start;
  }

  .SpotsPage_metaValue__bb74M {
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/spots/SpotsPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yFAAyF;EACzF,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yFAAyF;EACzF,0CAA0C;EAC1C,mBAAmB;EACnB,mDAAmD;EACnD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,uFAAuF;AACzF;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".pageHeader {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.pageTitle {\n  margin: 0;\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.pageSubtitle {\n  margin: 6px 0 0;\n  font-size: 0.95rem;\n  color: #64748b;\n  max-width: 480px;\n  line-height: 1.45;\n}\n\n.metrics {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.metric {\n  min-width: 120px;\n  padding: 12px 16px;\n  border-radius: 14px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background: linear-gradient(135deg, rgba(248, 250, 252, 0.95), rgba(226, 232, 240, 0.65));\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.metricValue {\n  font-size: 1.45rem;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.2;\n}\n\n.metricLabel {\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.actionsBar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.searchWrapper {\n  flex: 1 1 280px;\n  min-width: 220px;\n}\n\n.createWrapper {\n  display: flex;\n  align-items: center;\n}\n\n.infoBanner {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.spotsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 24px;\n  width: 100%;\n}\n\n.spotCard {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.97), rgba(248, 250, 252, 0.96));\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  border-radius: 24px;\n  box-shadow: 0 24px 45px -30px rgba(15, 23, 42, 0.4);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cardMedia {\n  position: relative;\n  width: 100%;\n  padding-top: 58%;\n  background: rgba(15, 23, 42, 0.03);\n}\n\n.spotImage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.spotBadge {\n  position: absolute;\n  top: 14px;\n  left: 14px;\n  background: rgba(15, 23, 42, 0.72);\n  color: #f8fafc;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 6px 12px;\n  border-radius: 999px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.35);\n}\n\n.cardBody {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.cardHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cardTitle {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.cardSubtitle {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.metaList {\n  display: grid;\n  gap: 10px;\n}\n\n.metaItem {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.metaLabel {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #475569;\n  letter-spacing: 0.02em;\n}\n\n.metaValue {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #0f172a;\n  text-align: right;\n}\n\n.surveySection {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 16px;\n  border-radius: 14px;\n  border: 1px solid rgba(37, 99, 235, 0.18);\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08), rgba(96, 165, 250, 0.05));\n}\n\n.surveySectionEmpty {\n  border: 1px dashed rgba(148, 163, 184, 0.6);\n  background: rgba(248, 250, 252, 0.55);\n}\n\n.surveyTitle {\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #2563eb;\n}\n\n.surveyTitleEmpty {\n  color: #64748b;\n}\n\n.surveyValue {\n  font-size: 0.95rem;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.surveyMeta {\n  font-size: 0.82rem;\n  color: #475569;\n}\n\n.progressSection {\n  display: grid;\n  gap: 10px;\n}\n\n.progressLabel {\n  font-size: 0.82rem;\n  color: #475569;\n  font-weight: 600;\n}\n\n.ctaGroup {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 10px;\n}\n\n.divider {\n  height: 1px;\n  background: rgba(226, 232, 240, 0.7);\n  margin: 0 -24px;\n}\n\n.emptyState {\n  padding: 96px 24px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 1.05rem;\n  font-weight: 600;\n}\n\n@media (max-width: 600px) {\n  .cardBody {\n    padding: 20px;\n  }\n\n  .metaItem {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .metaValue {\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `SpotsPage_pageHeader__sKx7V`,
	"pageTitle": `SpotsPage_pageTitle__8kOfI`,
	"pageSubtitle": `SpotsPage_pageSubtitle__Lx8B0`,
	"metrics": `SpotsPage_metrics__kq0V7`,
	"metric": `SpotsPage_metric__hv5uu`,
	"metricValue": `SpotsPage_metricValue__wqsKy`,
	"metricLabel": `SpotsPage_metricLabel__Ncmxi`,
	"actionsBar": `SpotsPage_actionsBar__EkLkn`,
	"searchWrapper": `SpotsPage_searchWrapper__41iWZ`,
	"createWrapper": `SpotsPage_createWrapper__gI54e`,
	"infoBanner": `SpotsPage_infoBanner__+GZa+`,
	"spotsGrid": `SpotsPage_spotsGrid__oSsR4`,
	"spotCard": `SpotsPage_spotCard__-uj+6`,
	"cardMedia": `SpotsPage_cardMedia__A5bQD`,
	"spotImage": `SpotsPage_spotImage__bPULC`,
	"spotBadge": `SpotsPage_spotBadge__yz6Mm`,
	"cardBody": `SpotsPage_cardBody__zqrY6`,
	"cardHeader": `SpotsPage_cardHeader__2Ymym`,
	"cardTitle": `SpotsPage_cardTitle__9ZgFn`,
	"cardSubtitle": `SpotsPage_cardSubtitle__WPpit`,
	"metaList": `SpotsPage_metaList__YjMC6`,
	"metaItem": `SpotsPage_metaItem__58---`,
	"metaLabel": `SpotsPage_metaLabel__6tONP`,
	"metaValue": `SpotsPage_metaValue__bb74M`,
	"surveySection": `SpotsPage_surveySection__jPt0P`,
	"surveySectionEmpty": `SpotsPage_surveySectionEmpty__GL-Pt`,
	"surveyTitle": `SpotsPage_surveyTitle__I6+Cm`,
	"surveyTitleEmpty": `SpotsPage_surveyTitleEmpty__+5RV6`,
	"surveyValue": `SpotsPage_surveyValue__ZJboI`,
	"surveyMeta": `SpotsPage_surveyMeta__n8f2Q`,
	"progressSection": `SpotsPage_progressSection__Ak+z+`,
	"progressLabel": `SpotsPage_progressLabel__icm1s`,
	"ctaGroup": `SpotsPage_ctaGroup__1vEuS`,
	"divider": `SpotsPage_divider__i9hdc`,
	"emptyState": `SpotsPage_emptyState__sqYx8`
};
export default ___CSS_LOADER_EXPORT___;
